import React from 'react';
import {Col, Row} from "reactstrap";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default class People extends React.Component {

    render() {

        const {handleChangePage, pagesData} = this.props;

        return <div className={'ilead-tools-group'}>

            <div>
                <Row>
                    <Col sm={12}>Mobilising</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to motivate others</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToMotivateOthers']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToMotivateOthers')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to raise energy levels</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToRaiseEnergyLevels']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToRaiseEnergyLevels')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to be assertive</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToBeAssertive']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToBeAssertive')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to influence others</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToInfluenceOthers']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToInfluenceOthers')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col sm={12}>Connecting</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to develop rapport</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToDevelopRapport']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToDevelopRapport')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to communicate effectively</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToCommunicateEffectively']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToCommunicateEffectively')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to actively listen</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToActivelyListen']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToActivelyListen')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to manage your impact</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToManageYourImpact']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToManageYourImpact')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to manage difficult conversations</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToManageDifficultConversations']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToManageDifficultConversations')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col sm={12}>Building</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to create team identity</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToCreateTeamIdentity']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToCreateTeamIdentity')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to build and maintain trust</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToBuildAndMaintainTrust']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToBuildAndMaintainTrust')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to gain buy-in and commitment</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToGainBuyInAndCommitment']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToGainBuyInAndCommitment')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to support and challenge in tandem</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToSupportAndChallengeInTandem']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToSupportAndChallengeInTandem')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to give feedback</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToGiveFeedback']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToGiveFeedback')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col sm={12}>Meaning</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to identify your personal meaning</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToIdentifyYourPersonalMeaning']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToIdentifyYourPersonalMeaning')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to be an effective role model</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToBeAnEffectiveRoleModel']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToBeAnEffectiveRoleModel')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to identify personal learning styles</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToIdentifyPersonalLearningStyles']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToIdentifyPersonalLearningStyles')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to develop others</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToDevelopOthers']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }
                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToDevelopOthers')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
            </div>
        </div>;
    }
}